<div style="position:sticky; top:-1px; z-index:100;">
    <app-dp-bottom-sheet-closer (closeClicked)="closesheet()">
    </app-dp-bottom-sheet-closer>
</div>

<div class="add-oblate-body">
    <div class="header-text">Select ‘Add Oblate’ type</div>
    @for (item of addOblateType; track $index) {
    <button class="add-oblate-type" (click)="selectedType(item.type)">
        <div class="oblate-type-title">
            <label>{{item.title}}</label>
            <div class="radio"></div>
        </div>
        <div class="add-type-description">{{item.description}}</div>
    </button>
    }

    <div class="btn-group">
        <button class="dp-primary-btn btn-primary" type="button" (click)="onSelectAddOblateType()">Proceed</button>
        <button class="dp-tertiary-btn" (click)="closesheet()">Cancel</button>
    </div>
</div>